module.exports = __webpack_public_path__ + "img/deco_home.b54751e7.svg";